import type { PocInputValidity } from 'commons/types';
import { useEffect, useState } from 'react';
import { useErroneousCombinations } from './use-device-configuration.hook';

export const useConfigurationValidation = () => {
    const { deviceConfigurationValidation, setDeviceConfigurationValidation, checkErroneousCombinations } =
        useErroneousCombinations();
    const [isConfigurationValid, setIsConfigurationValid] = useState<boolean>(true);

    useEffect(() => {
        setIsConfigurationValid(
            !Object.values(deviceConfigurationValidation).some((entry) => entry.validity?.state === 'error')
        );
    }, [deviceConfigurationValidation]);

    const setValidation = (
        propertyName: string,
        validity: PocInputValidity,
        code?: string,
        targetProperty?: string
    ) => {
        const newValidation = {
            ...deviceConfigurationValidation,
            [propertyName]: {
                validity,
                erroneousCombinations: code
                    ? [{ code, targetProperty: targetProperty ?? '', sourceProperty: propertyName }]
                    : [],
            },
        };

        setDeviceConfigurationValidation(newValidation);
    };

    return {
        deviceConfigurationValidation,
        setValidation,
        isConfigurationValid,
        checkErroneousCombinations,
    };
};
